import { StockService } from 'api-new/generated';
import { UseQueryOptions, useQuery } from 'react-query';

export const stockRequirementsCsvQueryKey = 'StockRequirementsCsvQuery';

const fetchStockRequirementsCsv = (branchId?: number, manufId?: number) => {
  return StockService.getVehiclesStockCalculateStockRequirementsCsv(branchId, manufId);
};

export const useStockRequirementsCsvQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  { branchId, manufId }: { branchId?: number; manufId?: number } = {},
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchStockRequirementsCsv>>,
      unknown,
      Awaited<ReturnType<typeof fetchStockRequirementsCsv>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [stockRequirementsCsvQueryKey, ...(queryKey ?? [{ branchId, manufId }])],
    () => fetchStockRequirementsCsv(branchId, manufId),
    options
  );
